import { User } from "oidc-client-ts";

// "Nachname Vorname" to match the FSW convention used across the app (e.g. "Hofer Maria").
export function getUserDisplayName(user: User | null | undefined): string {
  const profile = user?.profile;
  if (!profile) {
    return "";
  }
  const familyName = profile.family_name?.trim();
  const givenName = profile.given_name?.trim();
  if (familyName || givenName) {
    return [familyName, givenName].filter(Boolean).join(" ");
  }
  return profile.name ?? profile.preferred_username ?? "";
}

export function getUserInitials(user: User | null | undefined): string {
  const profile = user?.profile;
  const initials = [profile?.family_name, profile?.given_name]
    .map((part) => part?.trim().charAt(0).toUpperCase())
    .filter(Boolean)
    .join("");
  return initials || (profile?.preferred_username?.charAt(0).toUpperCase() ?? "");
}
